import { Component, Input, OnChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { BasePackagingComponent } from '../_base-packaging.component';


@Component({
  moduleId: module.id,
  selector: 'dimensions-information',
  templateUrl: 'dimensions.component.html',
  styleUrls: ['dimensions.component.scss'],
})
export class DimensionsComponent extends BasePackagingComponent implements OnChanges {

  @Input() declare itemDetailsData: any;

  @Input() declare data: any;

  @Input() formGroup: UntypedFormGroup;

  packageData: Array<any> = [];
  packageFields: Array<string> = [
    'orderable', 'quantity'
  ];

  dimensionsData: Array<any> = [];
  dimensionsFields: Array<string> = [
    'dimensions.length', 'dimensions.width',
    'dimensions.height', 'dimensions.uom'
  ];

  weightData: Array<any> = [];
  weightFields: Array<string> = [
    'weight_variance', 'weights.weight',
    'weights.dimensional_weight', 'weights.uom'
  ];

  ngOnChanges() {
    this.prepareData();
  }

  prepareData() {
    const packageData = this.separateData(this.data, this.packageFields);
    this.packageData = (<any>packageData)['true'];
    const dimensionsData = this.separateData((<any>packageData)['false'], this.dimensionsFields);
    this.dimensionsData = (<any>dimensionsData)['true'];
    const weightData = this.separateData((<any>packageData)['false'], this.weightFields);
    this.weightData = (<any>weightData)['true'];
  }
}
